export interface Figure {
  id: string;
  code: string;
  nick: string;
  category: string;
  area: string;
  status: string;
  hot: string;
  tags: string[];
  summary: string;
  updated: string;
  keypoint: string;
}

export const figures: Figure[] = [
  {
    id: "ren-01",
    code: "档案 A-01",
    nick: "「温柔学姐」人设反差",
    category: "人设崩塌型",
    area: "教育 / 情感",
    status: "持续追踪",
    hot: "93",
    tags: ["立人设", "私信证据", "多方对质"],
    summary:
      "当事人长期以「温柔学姐」形象输出情感建议，后被网友对比其私下言行与公开人设存在明显落差。目前流传的截图为单方面呈现，人物真实姓名尚未被权威渠道确认，属典型「待核验」样本。",
    updated: "2026-08-28",
    keypoint: "冲突点：公开人设 vs 私下言行",
  },
  {
    id: "ren-02",
    code: "档案 B-02",
    nick: "「探店顶流」收入争议",
    category: "身份与收入型",
    area: "消费 / 商业",
    status: "持续追踪",
    hot: "88",
    tags: ["收入流水", "签约公司", "税务争议"],
    summary:
      "围绕某探店类头部账号的真实收入与签约背景出现多轮讨论，涉及其对外展示的创业人设与其背后资方关系。各类财务截图来源分散，数值存在多个版本，尚未完成交叉验证。",
    updated: "2026-08-25",
    keypoint: "冲突点：公开创业故事 vs 资方关系",
  },
  {
    id: "ren-03",
    code: "档案 C-03",
    nick: "「公益人设」捐资疑云",
    category: "公益与道德型",
    area: "公益 / 舆论",
    status: "待核验",
    hot: "81",
    tags: ["捐赠凭证", "项目去向", "舆论反转"],
    summary:
      "当事人多次以「长期投身公益」作为公开标签，随后关于其具体捐赠规模与项目落地情况引发追问。目前仅有部分项目公示信息可检索，公开宣称与落地证据之间仍存在缺口。",
    updated: "2026-08-20",
    keypoint: "冲突点：宣称规模 vs 可核验记录",
  },
  {
    id: "ren-04",
    code: "档案 D-04",
    nick: "「考编学霸」背景反转",
    category: "学历背景型",
    area: "教育 / 就业",
    status: "持续追踪",
    hot: "76",
    tags: ["学历核实", "履历断层", "公告对照"],
    summary:
      "当事人在多个采访中强调的备考经历与其公开履历存在时间线矛盾。多方网友调用其早年获奖与毕业信息进行比对，但各渠道口径不一，人物确切身份与履历仍未定案。",
    updated: "2026-08-15",
    keypoint: "冲突点：采访口述 vs 履历时间线",
  },
  {
    id: "ren-05",
    code: "档案 E-05",
    nick: "「破产老板」豪车风波",
    category: "财富反差型",
    area: "商业 / 生活",
    status: "待核验",
    hot: "70",
    tags: ["破产自述", "高消费记录", "债权人质疑"],
    summary:
      "某自称「经营失败、生活清贫」的账号主，其过往消费与名下关联公司信息被陆续挖出，引发「卖惨」质疑。相关登记与消费记录由不同网友提供，真实个人身份尚需核实。",
    updated: "2026-08-10",
    keypoint: "冲突点：卖惨自述 vs 关联消费",
  },
  {
    id: "ren-06",
    code: "档案 F-06",
    nick: "「清醒女性」私下录音",
    category: "观点与行为型",
    area: "情感 / 社群",
    status: "持续追踪",
    hot: "84",
    tags: ["录音流传", "价值观争议", "粉丝反噬"],
    summary:
      "长期输出「清醒、独立」观点的博主，被传出与其公开立场相悖的私下言论录音。录音真实性及剪辑程度存在广泛讨论，人物本人尚未完整回应，属于舆论发酵中的高危样本。",
    updated: "2026-08-30",
    keypoint: "冲突点：公开立场 vs 私密言论",
  },
];